// extracted by mini-css-extract-plugin
export default {"container":"Map_container__veWWf","map":"Map_map__A2O+-"};